import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { adminApiClient } from "../../lib/adminApiClient";
import { queryKeys } from "../../lib/queryClient";
import { ErrorBanner, LoadingState } from "../../components/States";
import { formatDateTime } from "../../lib/format";

const KIND_LABEL: Record<string, string> = {
  wallet_address: "Wallet address",
  whatsapp_link: "WhatsApp link",
  phone_number: "Phone number",
};

export function AdminFlaggedMessagesPage() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.adminFlaggedMessages,
    queryFn: () => adminApiClient.listFlaggedMessages({ limit: 50 }),
  });

  return (
    <div className="stack">
      <div>
        <h1>Flagged chats</h1>
        <p className="muted text-sm">
          Messages blocked for containing a phone number, WhatsApp link, or wallet address — an
          attempt to move a deal off-platform. The message content itself was never stored.
        </p>
      </div>

      {isLoading && <LoadingState label="Loading flagged messages…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}

      {data && (
        <div style={{ overflowX: "auto" }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Reason</th>
                <th>Conversation</th>
                <th>When</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((m) => (
                <tr key={m.id}>
                  <td>
                    {m.actorId ? (
                      <Link to={`/admin/users/${m.actorId}`}>{m.actorUsername ?? m.actorId.slice(0, 8)}</Link>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td>{m.kind ? (KIND_LABEL[m.kind] ?? m.kind) : "—"}</td>
                  <td className="mono text-sm">{m.conversationId?.slice(0, 8) ?? "—"}</td>
                  <td>{formatDateTime(m.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.items.length === 0 && <p className="muted">No flagged messages.</p>}
        </div>
      )}
    </div>
  );
}
